import React, { useState } from 'react';
import { Modal, Button, Input, TextArea } from '../ui';

const ICONS = ['🎸', '🎤', '🎹', '🥁', '🎺', '🎻', '🎵', '🔥', '💀', '🌙', '⚡', '🏴', '🐊', '🦅', '🌾', '🍺'];

interface SaveSessionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, description: string, icon: string, tags: string[]) => void;
}

export const SaveSessionModal: React.FC<SaveSessionModalProps> = ({ isOpen, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('🎸');
  const [tagsInput, setTagsInput] = useState('');

  const handleSave = () => {
    if (!name.trim()) return;
    const tags = tagsInput.split(',').map(t => t.trim()).filter(Boolean);
    onSave(name.trim(), description.trim(), icon, tags);
    setName('');
    setDescription('');
    setIcon('🎸');
    setTagsInput('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Save Session Memory"
      size="md"
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
          <Button variant="primary" size="sm" onClick={handleSave} disabled={!name.trim()}>Save Session</Button>
        </div>
      }
    >
      <div className="space-y-5">
        <div className="space-y-2">
          <label className="text-[11px] font-black text-slate-400 uppercase tracking-widest">Icon</label>
          <div className="flex flex-wrap gap-2">
            {ICONS.map(i => (
              <button
                key={i}
                onClick={() => setIcon(i)}
                className={`w-9 h-9 rounded-lg text-lg flex items-center justify-center transition-all ${
                  icon === i
                    ? 'bg-accent/20 ring-2 ring-accent scale-110'
                    : 'bg-slate-800 hover:bg-slate-700'
                }`}
              >
                {i}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-2">
          <label htmlFor="session-name" className="text-[11px] font-black text-slate-400 uppercase tracking-widest">Session Name *</label>
          <Input
            id="session-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Southern Doom Setup, Album 3 Vocal Chain..."
            className="!bg-slate-900 !border-slate-700"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="session-description" className="text-[11px] font-black text-slate-400 uppercase tracking-widest">Description</label>
          <TextArea
            id="session-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What's this session about?"
            rows={2}
            className="!bg-slate-900 !border-slate-700"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="session-tags" className="text-[11px] font-black text-slate-400 uppercase tracking-widest">Tags (comma-separated)</label>
          <Input
            id="session-tags"
            value={tagsInput}
            onChange={(e) => setTagsInput(e.target.value)}
            placeholder="e.g., doom, heavy, experimental"
            className="!bg-slate-900 !border-slate-700"
          />
        </div>
      </div>
    </Modal>
  );
};
